import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import _, { isEmpty, split } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const TenableScMappingForm = forwardRef(function TenableScMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { assetId, assetName } = props.record;
      const assetIdArray = split(assetId, ",");
      const assetNameArray = split(assetName, ",");
      return assetIdArray.map((id, index) => ({
        id,
        name: assetNameArray[index],
      }));
    }
    return [];
  });
  const [ loading, setLoading ] = useState(true);

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setProjects(projects);
    }).catch(() => {
      message.error('Problem fetching projects');
    }).finally(()=>{
      setLoading(false);
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = useCallback((config) => {
    const { assetId } = config;
    if(!isEmpty(assetId)){
      const assetName =  _.filter(projects, (project) =>
        assetId.includes(project.id)
          ).map((asset) => asset.name);
      return {
        assetId: assetId.join(),
        assetName: assetName.join(),
      };
    }
    return;
  }, [projects]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
      const { assetId } = config;
      return {
        assetId: assetId ? split(assetId, ",") : undefined,
      };
    }, []);

  const extraFields = useMemo(() => ([
    {
      name: 'assetId',
      colSpan: '12',
      type: FieldTypes.MULTI_SELECT,
      placeholder: "Leave blank to select all by default",
      label: 'Tenable.sc Assets',
      options: projects.map(option => {
        const { label = option.name, value = option.id } = option;
        return { label, value }
      }),
      loading,
      props: {
        autoFocus: true
      }
    }
  ]), [projects, loading]);

  return (
    <GenericMappingForm
      title="Map Tenable.sc Assets"
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default TenableScMappingForm;
